import {
    useContext,
    createContext,
} from 'react'

import {
    LongTermLeaseType,
} from '../../longTermLease.types'

export type LongTermLeaseInvoicesContextType = {
    longTermLease: LongTermLeaseType
}

export const LongTermLeaseInvoicesContext = createContext<LongTermLeaseInvoicesContextType>(null)

const useLongTermLeaseInvoicesContext = () => {
    return useContext<LongTermLeaseInvoicesContextType>(LongTermLeaseInvoicesContext)
}

export default useLongTermLeaseInvoicesContext
